import { auth, db } from "../firebase.config";
import { signInWithEmailAndPassword, signInWithPopup } from "firebase/auth";
import { collection, query, where, getDocs } from "firebase/firestore";

export const authService = {
  // Validate if a user belongs to an organization
  async validateOrgUser(email) {
    // Check if user exists in org_users collection
    const orgUsersQuery = query(
      collection(db, "org_users"),
      where("email", "==", email)
    );

    const orgUsersSnapshot = await getDocs(orgUsersQuery);

    if (orgUsersSnapshot.empty) {
      throw new Error(
        "User not authorized. Please contact your organization administrator."
      );
    }

    const orgUser = {
      id: orgUsersSnapshot.docs[0].id,
      ...orgUsersSnapshot.docs[0].data(),
    };

    // Check if user is active
    if (orgUser.status !== "active") {
      throw new Error(
        "Your account is not active. Please contact your organization administrator."
      );
    }

    return orgUser;
  },

  async loginUser(email, password) {
    try {
      const orgUser = await this.validateOrgUser(email);

      // If user exists in org_users, proceed with Firebase authentication
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );

      return {
        user: {
          ...userCredential.user,
          org_id: orgUser.org_id,
          role: orgUser.role,
          permissions: orgUser.permissions,
          status: orgUser.status,
        },
        token: await userCredential.user.getIdToken(),
      };
    } catch (error) {
      if (error.message) {
        throw error;
      } else {
        throw new Error("Invalid login credentials");
      }
    }
  },

  async loginWithGoogle(googleProvider) {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const email = result.user.email;

      // Validate organization user after Google sign-in
      const orgUser = await this.validateOrgUser(email);

      return {
        user: {
          ...result.user,
          org_id: orgUser.org_id,
          role: orgUser.role,
          permissions: orgUser.permissions,
          status: orgUser.status,
        },
        token: await result.user.getIdToken(),
      };
    } catch (error) {
      if (error.message) {
        throw error;
      } else {
        throw new Error("Google authentication failed");
      }
    }
  },
};
